import { dataHooks } from '../../../../../libs/dataHooks';

export const widgetFeatureCarouselDataHooks = dataHooks<{
  title;
  description;
  imageWrapper;
  image;
}>('widget-feature-carousel');
